import { ApaduaAPI } from './ApaduaAPI';

export class LanguagesAPI extends ApaduaAPI {
    resource: string = 'api/languages/';

    getLanguages(): Promise<Array<any>> {
        return this.get('') as any;
    }
}
